
@if (!loading) {
  <div class="w-100 flex-direction-column align-items-center transfer-page-container">
    <div class="transfer-page mt-30px">
      @if ((isWalletToWallet && paymentReceipt) || (!isWalletToWallet && productBuyingResponse)) {
        <div class="flex-direction-row w-100 gap-12px trc__mockup-container">
          <img src="assets/svg/mockup-success.svg" alt="icon">
          <div class="mockup-text">{{ successMessageKey | translate }}</div>
        </div>
      }

      @if (isWalletToWallet && paymentReceipt) {
        <div class="flex-direction-column gap-20px w-100">
          <div class="transfer-receipt-container">
            <span class="trc__title">{{ transferTitleKey | translate }}</span>

            <div class="trc__data-container">
              <div class="w-100 flex-direction-row justify-content-between">
                <span class="trc__data">{{ 'payment_receipt.transaction_id' | translate }}</span>
                <span class="trc__data">{{ paymentReceipt.transactionID }}</span>
              </div>
              <div class="w-100 flex-direction-row justify-content-between">
                <span class="trc__data">{{ buyerFieldTitle }}</span>
                <span class="trc__data">{{ paymentReceipt.cardName }}</span>
              </div>
              <div class="w-100 flex-direction-row justify-content-between">
                <span class="trc__data">{{ 'payment_receipt.scan_me_username' | translate }}</span>
                <span class="trc__data">{{ paymentReceipt.username }}</span>
              </div>
              @if (paymentReceipt.commissionFee && paymentReceipt.commissionFee > 0) {
                <div class="w-100 flex-direction-row justify-content-between">
                  <span class="trc__data">{{ 'payment_receipt.amount' | translate }}</span>
                  <span class="trc__data">{{ paymentReceipt.amount + ' ' + ('subscription_plan_content.AMD' | translate)}}</span>
                </div>
                <div class="w-100 flex-direction-row justify-content-between">
                  <span class="trc__data">{{ 'payment_receipt.commission_fee' | translate }}</span>
                  @if (paymentReceipt.commissionFeeUnit === 'MONEY') {
                    <span class="trc__data">{{ paymentReceipt.commissionFee + ' ' + ('subscription_plan_content.AMD' | translate) }}</span>
                  } @else {
                    <span class="trc__data">{{ paymentReceipt.commissionFee }}%</span>
                  }
                </div>
                <div class="w-100 flex-direction-row justify-content-between">
                  <span class="trc__data">{{'payment_receipt.total_amount_paid' | translate}}</span>
                  <span class="trc__data">{{ paymentReceipt.totalAmount + ' ' + ('subscription_plan_content.AMD' | translate)}}</span>
                </div>
              } @else {
                <div class="w-100 flex-direction-row justify-content-between">
                  <span class="trc__data">{{'payment_receipt.total_amount_paid' | translate}}</span>
                  <span class="trc__data">{{ paymentReceipt.totalAmount + ' ' + ('subscription_plan_content.AMD' | translate)}}</span>
                </div>
              }
            </div>
          </div>

          <div class="w-100 d-flex justify-content-center">
            <button type="button" (click)="goBack()" class="filled-button short-button">{{ 'payment_receipt.go_back' | translate }}</button>
          </div>
        </div>
      } @else if (!isWalletToWallet && productBuyingResponse) {
        <div class="flex-direction-column gap-20px w-100">
          <div class="transfer-receipt-container">
            <span class="trc__title">{{ 'payment.product_purchase' | translate }}</span>

            <div class="trc__data-container">
              <div class="w-100 flex-direction-row justify-content-between">
                <span class="trc__data">{{ 'payment.transaction_id' | translate }}</span>
                <span class="trc__data">{{ productBuyingResponse?.id }}</span>
              </div>
              <div class="w-100 flex-direction-row justify-content-between">
                <span class="trc__data">{{ 'payment.paid_by' | translate }}</span>
                <span class="trc__data">{{ productBuyingResponse?.userInfo?.email ?? '-' }}</span>
              </div>
              <div class="w-100 flex-direction-row justify-content-between">
                <span class="trc__data">{{ 'payment.total_amount_paid' | translate }}</span>
                <span class="trc__data">{{ (productBuyingResponse?.totalAmount ?? 0) + ' ' + ('subscription_plan_content.AMD' | translate)}}</span>
              </div>
            </div>
          </div>

          <div class="w-100 d-flex justify-content-center">
            <button routerLink="/products" class="filled-button short-button">{{ 'payment.go_back' | translate }}</button>
          </div>
        </div>
      }

    </div>
  </div>
} @else {
  <div class="loading-container">
    <div class="search-loader">
      <div class="spinner-border" role="status">
        <span class="visually-hidden">Loading...</span>
      </div>
    </div>
  </div>
}
